/**
 * Responsive constants for the Kanban board (alerts).
 * Aligned with flow diagram patterns — use with Chakra responsive props / useBreakpointValue.
 *
 * Breakpoints: base (0), sm (480px), md (768px), lg (1024px), xl (1280px), 2xl (1536px), 3xl (1920px), 4xl (2560px)
 */

/** Gaps between board columns */
export const KANBAN_BOARD_GAPS = {
  base: 2,
  md: 3,
  lg: 4,
  xl: 5,
  "4xl": 6,
} as const

/** Column minimum width: full width stacked on small screens */
export const KANBAN_COLUMN_MIN_W = {
  base: "100%",
  sm: "100%",
  md: "260px",
  lg: "280px",
  xl: "300px",
  "2xl": "320px",
  "4xl": "360px",
} as const

/** Column minimum height */
export const KANBAN_COLUMN_MIN_H = {
  base: "min(42vh, 480px)",
  md: "60vh",
  lg: "62.5vh",
  xl: "65vh",
  "2xl": "67.5vh",
  "4xl": "70vh",
} as const

/** Column inner padding */
export const KANBAN_COLUMN_P = {
  base: 2,
  md: 3,
  lg: 3,
} as const

/** Column header title */
export const KANBAN_COLUMN_TITLE_FS = {
  base: "sm",
  lg: "md",
  "2xl": "md",
  "4xl": "lg",
} as const

/** Main board container min height */
export const KANBAN_BOARD_MIN_H = {
  base: "min(360px, 70vh)",
  md: "400px",
  lg: "420px",
} as const

/** Alert card outer padding */
export const KANBAN_CARD_P = {
  base: 2,
  md: 2,
  lg: 3,
  "4xl": 3,
} as const

/** Indent step per level of the alert card's context hierarchy tree */
export const KANBAN_CONTEXT_INDENT_PX = 10

/** Assignee control: larger on small screens for touch */
export const KANBAN_ASSIGNEE_CIRCLE = {
  base: "28px",
  sm: "28px",
  md: "24px",
  lg: "24px",
  "4xl": "28px",
} as const

/** CSS var for Avatar fallback font inside assignee circle */
export const KANBAN_ASSIGNEE_AVATAR_FONT = {
  base: "8px",
  md: "10px",
  "4xl": "12px",
} as const

/** Drag overlay card width (use with useBreakpointValue) */
export const KANBAN_DRAG_OVERLAY_W = {
  base: "min(100%, 320px)",
  sm: "300px",
  md: "280px",
  lg: "300px",
  xl: "320px",
  "2xl": "340px",
} as const
